import { getFullLocale } from '../util/Localizer'
export const formatCurrency = (value) => {
  return Intl.NumberFormat(getFullLocale(), { style: 'currency', currency: 'CAD' }).format(value || 0).replace('CA', '')
}



// WEBPACK FOOTER //
// ./src/util/CurrencyFormatter.js